var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9095 6.07084C12.1677 5.85783 12.5717 5.83846 12.8563 6.01274L12.9379 6.07084L19.6095 11.5757C19.8677 11.7888 19.8911 12.1221 19.6799 12.357L19.6095 12.4243L12.9379 17.9292C12.6539 18.1635 12.1935 18.1635 11.9095 17.9292C11.6514 17.7162 11.6279 17.3828 11.8391 17.1479L11.9095 17.0806L18.067 12L11.9095 6.91937C11.6514 6.70635 11.6279 6.37302 11.8391 6.13813L11.9095 6.07084Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrow);
export default __webpack_public_path__ + "static/media/icon-arrow.4d3d40b709aba51cf8f1a3a951b3f63d.svg";
export { ForwardRef as ReactComponent };